<template>
  <footer class="bg-primary sombra">
    <div class="container bg-primary">
      <div class="pt-5 ml-4 ml-md-0">
        <img src="@/assets/images/Logo-Kia.png" alt="KIA LOGO" class="img-fluid bounceIn logo-foo">
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
footer {
  height: 10em;
}
.logo-foo{
  max-width: 8em;
}
.sombra {
  -webkit-box-shadow: 0px -2px 81px -10px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0px -2px 81px -10px rgba(0, 0, 0, 0.8);
  box-shadow: 0px -2px 81px -10px rgba(0, 0, 0, 0.8);
}
</style>
